import { render, staticRenderFns } from "./pubIndex.vue?vue&type=template&id=19431d10&scoped=true&"
import script from "./pubIndex.vue?vue&type=script&lang=js&"
export * from "./pubIndex.vue?vue&type=script&lang=js&"
import style0 from "./pubIndex.vue?vue&type=style&index=0&id=19431d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19431d10",
  null
  
)

export default component.exports